import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';

// eslint-disable-next-line import/no-unassigned-import
import './index.css';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element not found');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
